<template>
  <div class="academy-rules">
    <section class="section-top">

      <div v-if="ready">

      </div>
      <div v-else class="content-empty">
        <PageComingSoon :titleText="' '" :descriptionText="String(readyMsg)" />
      </div>

    </section>
  </div>
</template>

<script>
import PageComingSoon from '@/components/Common/PageComingSoon.vue';

export default {
  name: 'AcademyStaff',
  components: {PageComingSoon},
  data() {
    return {
      ready: false,
      readyMsg: '준비 중입니다'
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style scoped>
</style>